import Event from '@oppobrowser/lib-browser-event';
import template from './index.dot';
import axios from 'axios';
import './index.scss';
import { getHeaderKKUA } from '@js/native';
import Exposure from '../../js/exposure';
import { isNewPush } from '../../js/constants';
import { formatNumber } from '../../js/utils';
import moreIconTemplate from './moreIcon.dot';

/** 点击实时热搜跳转  */
const EventHandler = {
  jumpSearchPage(node, event) {
    event.stopPropagation();
    const index = Number(node.dataset.index);
    const item = this.data.data.querys[index];
    // 埋点
    // window.wv.generalStat(statId, category, module, data);
    let _data = {
      area: 'item',
      pos: Number(index + 1),
      content: item.word,
      source: item.source,
    };
    window.wv.generalStat('20084318', '10006', '21034', _data);
    if (window.wv.isMethodValid('BrowserIFlow.openHotPage')) {
      window.wv.invoke(
        'BrowserIFlow.openHotPage',
        Number(index + 1),
        JSON.stringify(item.jump),
      );
    }
  },
  /**点击查看完整 */
  jumpHotPage(node, event) {
    event.stopPropagation();
    window.wv.generalStat('20084318', '10006', '21034', { area: 'more' });
    if (window.wv.isMethodValid('BrowserIFlow.openHotPage')) {
      let url = new URL(window.pageData.pushHotSearch.hotMoreLink);
      let source = new URLSearchParams(url.search);
      let data = source.get('engine');
      if (data) {
        // 如果已经存在参数,先删除再添加
        source.delete('engine');
        source.append('engine', this.engine);
      } else {
        // 如果不存在参数,直接添加
        source.append('engine', this.engine);
      }
      let fillerUrl =
        url.origin + url.pathname + '?' + source.toString() + url.hash;
      window.wv.invoke('BrowserIFlow.openHotPage', 0, fillerUrl);
    }
  },
};

export default class HotSearch {
  constructor(el, name, data = {}) {
    this.el = el;
    this.data = {};
    this.darkTheme = false;
    this._eventHandler = {};
    this.engine = '';
  }
  /**初始化 */
  init() {
    Object.keys(EventHandler).forEach((fn) => {
      this._eventHandler[fn] = EventHandler[fn].bind(this);
    });
    this._bindEvent();
    this.getHotList();
    document.addEventListener('nightmodechange', () => {
      this.render();
    });
  }

  _bindEvent() {
    this._comEvent = new Event('click', this.el);
    this._comEvent.registeHandler(this._eventHandler);
  }
  /**接口查询实时热榜
   * getHeaderKKUA():获取顺序 优先X-KKBrowser-UA-V3,其次X-KKBrowser-UA-V2, X-KKBrowser-UA 传其中一个即可
   */
  async getHotList() {
    const kkua = await getHeaderKKUA();
    // push详情页获取引擎信息
    const engineData = wv.getSearchEngine() && wv.getSearchEngine().data;
    if (engineData) {
      this.engine = engineData.split('<|>')[0];
    } else {
      this.engine = 'toutiao';
    }
    let params = {
      f: 'json',
      engine: this.engine,
      path: 'detail_page_push_oppo',
      number: isNewPush ? 5 : 3,
      version: Number(window.wv.formatedVersionCode) || 0, // 当前客户端版本号
    };
    if (!window.pageData?.pushHotSearch?.hotListBaseUrl) {
      return;
    }
    await axios({
      url:
        window.pageData.pushHotSearch.hotListBaseUrl +
        '/v1/search/browser/hotList',
      method: 'get',
      timeOut: 15000,
      params,
      headers: kkua,
    }).then(
      (res) => {
        let { status, data = {} } = res;
        if (status == 200 && data.ret == 0) {
          let hotList = data.data ? data.data.hotItems : [];
          hotList.forEach((item) => {
            item.hotValue = formatNumber(item.hotValue);
          });
          this.data = {
            data: {
              querys: hotList,
            },
          };
          this.render();
        } else {
          console.log('接口报错！');
        }
      },
      (err) => {
        console.log(err.msg);
      },
    );
  }

  //数据曝光处理
  dataExposure() {
    let exposurer = new Exposure((node) => {
      let index = node.getAttribute('data-index');
      let currentList = this.data.data.querys[index];
      let _extendData = {
        pos: Number(index) + 1,
        content: currentList.word,
        source: currentList.source,
      };
      if (wv.isMethodValid('generalStat')) {
        wv.generalStat([20084319, 10006, 21034, JSON.stringify(_extendData)]);
      }
    });
    //监听
    exposurer.observe('.hot__item');
  }

  adaptNightMode() {
    this.darkTheme = window.store.nightMode;
  }

  render() {
    this.adaptNightMode();
    const { data } = this;
    let title = this.darkTheme
      ? require('@img/hot-search-light.png')
      : require('@img/hot-search-day.png');
    this.el.innerHTML = template({
      dataList: data.data?.querys || [],
      title: title || '',
      darkTheme: this.darkTheme || false,
      moreIcon: moreIconTemplate(),
    });
    this.dataExposure();
  }
}
